// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-services-box_portfolio_service_box__OmS8i {
    display: flex;
    cursor: pointer;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center !important;
}
.portfolio-services-box_portfolio_service_box__OmS8i div {
    width: 100%;
    height: 50px;
    max-width: 50px;
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #D6E5B8;
}
.portfolio-services-box_portfolio_service_box__OmS8i p {
    margin: 0;
    margin-top: 7px;
    font-size: 10px;
    color: #FFFFFF;
}

@media (min-width: 1200px) {
    .portfolio-services-box_portfolio_service_box__OmS8i div {
        height: 80px;
        max-width: 80px;
    }
    .portfolio-services-box_portfolio_service_box__OmS8i p {
        margin: 0 !important;
        margin-top: 24px !important;
        font-size: 15px !important;
    }
    .portfolio-services-box_portfolio_service_box__OmS8i img {
        margin: 0 !important;
        width: 100% !important;
        height: 100% !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/portfolio-services-box/portfolio-services-box.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,oBAAoB;QACpB,2BAA2B;QAC3B,0BAA0B;IAC9B;IACA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":[".portfolio_service_box {\r\n    display: flex;\r\n    cursor: pointer;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center !important;\r\n}\r\n.portfolio_service_box div {\r\n    width: 100%;\r\n    height: 50px;\r\n    max-width: 50px;\r\n    overflow: hidden;\r\n    border-radius: 50%;\r\n    border: 1px solid #D6E5B8;\r\n}\r\n.portfolio_service_box p {\r\n    margin: 0;\r\n    margin-top: 7px;\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .portfolio_service_box div {\r\n        height: 80px;\r\n        max-width: 80px;\r\n    }\r\n    .portfolio_service_box p {\r\n        margin: 0 !important;\r\n        margin-top: 24px !important;\r\n        font-size: 15px !important;\r\n    }\r\n    .portfolio_service_box img {\r\n        margin: 0 !important;\r\n        width: 100% !important;\r\n        height: 100% !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"portfolio_service_box": `portfolio-services-box_portfolio_service_box__OmS8i`
};
export default ___CSS_LOADER_EXPORT___;
